import React from 'react';
import { AutocompleteChangeReason } from "@mui/material";
import { AutocompleteOption } from "../../../../SortFilter/interfaces";
import { EquipmentTypeAutocomplete } from "../../StandardEnumSelects/EquipmentTypeAutocomplete";


type BoundEquipmentTypeAutocompleteProps<T> = {
  name: string;
  value?: string | number | null;
  onChange: (newQuery: T) => void;
}

const BoundEquipmentTypeAutocomplete = <T,>({
  name,
  value = '',
  onChange
}: BoundEquipmentTypeAutocompleteProps<T>) => {

  const handleChange = (_event: any, newValue: AutocompleteOption, reason: AutocompleteChangeReason) => {
    if (reason !== 'createOption') {
      onChange({
        [name]: newValue?.id ?? ''
      } as unknown as T);
    }
  };

  return <EquipmentTypeAutocomplete
    value={value}
    onChange={handleChange}
  />
}

export { BoundEquipmentTypeAutocomplete };